import React from 'react';
import i18n from 'i18next';

import { Carousel } from '../../../components/Widget';
import useRelated from './useRelated';

function Related(props: any): React.ReactElement {
  const related = useRelated(props);

  if (related.loading) return <>{i18n.t('loading')}</>;
  if (related.error) return <>{i18n.t('error')}</>;

  return <Carousel slides={related.data} />;
}

export default Related;
